/// Pure helpers for the TimelineView pendingScroll fallback chain.
/// Extracted from App.jsx so the chronological-fallback policy is
/// unit-testable without dragging a JSDOM render of the whole app
/// into the test suite.
///
/// The bug this guards against: Tim's 2026-06-16 PWA repro — "Open
/// today on the in-progress hero card landed on June 11 (the first
/// FIFA WC match day) instead of today". Root cause was the old
/// findFirstSegEl fallback walking the segments array and returning
/// the first one whose DOM element happened to render in time.

/// Given an array of timeline day-date keys (YYYY-MM-DD) and a
/// target date (YYYY-MM-DD), return an ORDERED list of candidate
/// fallback dates to scroll to, preferring the next chronologically
/// closest day to `target` (forward first, then backward).
///
/// Caller is expected to iterate candidates and pick the first one
/// whose DOM element actually exists. We deliberately don't touch
/// the DOM here — this is the pure policy.
///
/// Returns up to 2 dates. Order:
///   1. Nearest day >= target (forward fallback)
///   2. Nearest day < target (backward fallback)
///
/// If no dates are >= target, candidate 1 is the latest available
/// date. If no dates are < target, candidate 2 is omitted.
function nearestDayFallbackCandidates(dates, target) {
  if (!Array.isArray(dates) || !target) return [];
  const sorted = dates.filter(Boolean).slice().sort();
  if (sorted.length === 0) return [];
  const idx = sorted.findIndex((d) => d >= target);
  const candidates = [];
  if (idx >= 0) {
    candidates.push(sorted[idx]);
    if (idx > 0) candidates.push(sorted[idx - 1]);
  } else {
    // Every available date is BEFORE target — land on the latest.
    candidates.push(sorted[sorted.length - 1]);
  }
  return candidates;
}

module.exports = { nearestDayFallbackCandidates };
